import { config, IJsonRpcResponse } from "./api";

interface IAclManagementResponse extends IJsonRpcResponse {
    result: {
        success: boolean;
        error: string|null;
        resellerCompanyName: string;
        activeAgreements: IAgreementRow[];
    }
}

interface IEndEarlyResponse extends IJsonRpcResponse {
    result: {
        success: boolean;
        error: string|null;
    }
}

export interface IAgreementRow {
    agreementID: number;
    clientName: string;
    clientCompanyID: number;
    startDate: string;
    endDate: string;
}

export const getAclManagement = async (companyID: number) => {
    const res = await fetch(`${config.url}/aclManagement/${companyID}`, {
        headers: {
            'Authorization': 'Bearer ' + config.authToken,
            'Content-Type': 'application/json'
        },
        method: 'get',
        mode: 'cors'
    });

    const body: IAclManagementResponse = await res.json();
    return body.result;
};

export const endAgreementEarly = async (agreementID: number, noteContent: string) => {
    const data = {
        agreementID,
        noteContent,
    };

    const res = await fetch(`${config.url}/aclManagement/endAgreementEarly`, {
        body: JSON.stringify(data),
        headers: {
            'Authorization': 'Bearer ' + config.authToken,
            'Content-Type': 'application/json'
        },
        method: 'post',
        mode: 'cors'
    });

    const body: IEndEarlyResponse = await res.json();
    return body.result;
}
